export const actions = {
  set_state: 'print/set_state',
  delete: 'print/delete_print',
  get: 'print/get_print',
  get_one: 'print/get_one_print',
  update: 'print/update_print'
}
